<template>
  <div class="button-form-item-side-nav">
    <h6>{{ $t('button') }}</h6>
    <span>{{ $t('text') }}:</span>
    <Input :value="options.text" @enter="propChanged('text', $event)" @blur="propChanged('text', $event)" />
  </div>
</template>

<script>
import Mixin from '@/components/sidenav/landing/form/form-item/Mixin.js'

export default {
  name: 'ButtonFormItemSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.form.form-item.button' },
  mixins: [Mixin],
}
</script>
